import { pdfTableStyle } from "../../../../../misc/pdf/parts/Page";
import { PageRenderProvider } from "../../../../../misc/pdf/parts/PageContext";
import { ContainerPage } from "../../../../../misc/pdf/parts/ContainerPage";
import { ucWords } from "../../pricing/PriceRequestSubmittal";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export function KeyingSchedule(props) { return /*#__PURE__*/ _jsx(PageRenderProvider, { data: props.rows, onReady: props.onReady, children: list => /*#__PURE__*/ _jsx(ContainerPage, { children: /*#__PURE__*/ _jsxs("table", { className: pdfTableStyle, children: [/*#__PURE__*/ _jsx("thead", { children: /*#__PURE__*/ _jsxs("tr", { children: [/*#__PURE__*/ _jsx("th", { children: "Door #" }), /*#__PURE__*/ _jsx("th", { children: "Room Type" }), /*#__PURE__*/ _jsx("th", { children: "Lock Type" }), /*#__PURE__*/ _jsx("th", { children: "By" }), props.names.map(k => /*#__PURE__*/ _jsx("th", { children: k.name }, k.name))] }) }), /*#__PURE__*/ _jsxs("tbody", { children: [list.rows.length > 0 && !list.rows[0].isMisc && /*#__PURE__*/ _jsx("tr", { children: /*#__PURE__*/ _jsxs("th", { style: { paddingLeft: 40, backgroundColor: "#F8CBAD", fontWeight: "bold" }, colSpan: 4 + props.names.length, children: [convertToNth(list.rows.length ? list.rows[0].floor : "1"), " Floor"] }) }), list.rows.map((v, index) => { const isNewFloor = index > 0 && list.rows[index - 1].floor !== v.floor; const multi = v.grouppedItems.length > 1; const base = !multi ? v.grouppedItems[0] : undefined; return /*#__PURE__*/ _jsxs(_Fragment, { children: [isNewFloor && /*#__PURE__*/ _jsx("tr", { children: /*#__PURE__*/ _jsxs("th", { style: { paddingLeft: 40, backgroundColor: "#F8CBAD", fontWeight: "bold" }, colSpan: 4 + props.names.length, children: [convertToNth(v.floor), " Floor"] }) }), /*#__PURE__*/ _jsxs("tr", { children: [/*#__PURE__*/ _jsx("td", { rowSpan: multi ? v.grouppedItems.length + 1 : 1, children: v.name }), /*#__PURE__*/ _jsx("td", { children: v.locationTwo }), multi ? /*#__PURE__*/ _jsx("td", { colSpan: props.names.length + 2, style: { textAlign: "center" } }, "multi") : /*#__PURE__*/ _jsxs(_Fragment, { children: [/*#__PURE__*/ _jsx("td", { children: base && base.products.map(p => /*#__PURE__*/ _jsx("div", { children: p })) }), /*#__PURE__*/ _jsx("td", { children: base && base.by }), !v.keyed ? /*#__PURE__*/ _jsx("td", { colSpan: props.names.length, style: { textAlign: "center", backgroundColor: "#FFE699" }, children: "****NOT KEYED****" }, "not-keyed") : props.names.map(k => /*#__PURE__*/ _jsx("th", { style: { textAlign: "center" }, children: base && base.labelsSelected.indexOf(k.name) !== -1 ? "X" : "" }, k.name))] })] }), multi && v.grouppedItems.map(g => /*#__PURE__*/ _jsxs("tr", { children: [/*#__PURE__*/ _jsx("td", { children: ucWords(g.openingPart) }), /*#__PURE__*/ _jsx("td", { children: g.products.map(p => /*#__PURE__*/ _jsx("div", { children: p })) }), /*#__PURE__*/ _jsx("td", { children: g.by }), !v.keyed ? /*#__PURE__*/ _jsx("td", { colSpan: 1 + props.names.length, style: { textAlign: "center", backgroundColor: "#FFE699" }, children: "****NOT KEYED****" }, "not-keyed") : props.names.map(k => /*#__PURE__*/ _jsx("th", { style: { textAlign: "center" }, children: g.labelsSelected.indexOf(k.name) !== -1 ? "X" : "" }, k.name))] }))] }); })] })] }) }) }); }
function convertToNth(value) { value = (value || "").trim(); const val = parseInt(value); if (val.toString() !== value)
    return value; if (isNaN(val))
    return value; return toOrdinal(val); }
function toOrdinal(val) { switch (val) {
    case 1: return "First";
    case 2: return "Second";
    case 3: return "Third";
    case 4: return "Fourth";
    case 5: return "Fifth";
    case 6: return "Sixth";
    case 7: return "Seventh";
    case 8: return "Eighth";
    case 9: return "Nineth";
    case 10: return "Tenth";
    case 11: return "Eleventh";
    case 12: return "Twelfth";
    case 13: return "Thirteenth";
    case 14: return "Fourteenth";
    case 15: return "Fifteenth";
    case 16: return "Sixteenth";
    case 17: return "Seventeenth";
    case 18: return "Eighteenth";
    case 19: return "Nineteenth";
} if (val > 100) {
    return "Hundred and " + toOrdinal(val % 100);
}
else if (val === 100) {
    return "Hundredth";
} if (val > 90) {
    return "Ninety-" + toOrdinal(val % 90);
}
else if (val === 90) {
    return "Ninetieth";
} if (val > 80) {
    return "Eighty-" + toOrdinal(val % 80);
}
else if (val === 80) {
    return "Eightieth";
} if (val > 70) {
    return "Seventy-" + toOrdinal(val % 70);
}
else if (val === 70) {
    return "Seventieth";
} if (val > 60) {
    return "Sixty-" + toOrdinal(val % 60);
}
else if (val === 60) {
    return "Sixtieth";
} if (val > 50) {
    return "Fifty-" + toOrdinal(val % 50);
}
else if (val === 50) {
    return "Fiftieth";
} if (val > 40) {
    return "Forty-" + toOrdinal(val % 40);
}
else if (val === 40) {
    return "Fortieth";
} if (val > 30) {
    return "Thirty-" + toOrdinal(val % 30);
}
else if (val === 30) {
    return "Thirtieth";
} if (val > 20) {
    return "Twenty-" + toOrdinal(val % 20);
}
else if (val === 20) {
    return "Twentieth";
} return "invalid(" + val + ")"; }
